import MercuryNewsDashboardView from "src/sections/dashboards/platforms/mercury-news/mercury-news-dashboard-view";

const MercuryMainDashboardPage = () => <MercuryNewsDashboardView type="main" />;

export default MercuryMainDashboardPage;
